import { ck, URLS } from "fire-wind-water";
import $ from "jquery";
import commonService from "@/services/commonService.js";
// import URL from "@/assets/conf/setting.json";
export const domain = window.$sk.config.domain;
function removeSearchParam(sourceURL, ...agrs) {
  const a = document.createElement("a");
  a.href = decodeURIComponent(sourceURL);
  const searchs = a.search;
  let surl = "";
  if (searchs) {
    let searchArr = searchs.split("&");
    for (let i = 0; i < searchArr.length; i++) {
      let item = searchArr[i].split("=");
      if (agrs.indexOf(item[0]) !== -1) {
        searchArr.splice(i, 1);
        i--;
      }
    }
    if (searchArr.length > 0) {
      surl = `${searchArr.join("&")}`;
    }
    a.search = surl;
  }
  return a.href;
}
export default {
  weChatLoad(tenantId, weChatId, isSilentAuthorise) {
    let defer = $.Deferred();
    let scope = isSilentAuthorise ? "snsapi_base" : "snsapi_userinfo";
    let code = URLS.getURL("excode");
    let wxCode = URLS.getURL("code");
    let appid = URLS.getURL("appid");
    let token = ck.cookie("verify_" + weChatId);
    let tokenInfo = ck.cookie("verifyInfo_" + weChatId);
    if (tokenInfo && token) {
      defer.resolve({
        tokenInfo: tokenInfo,
        token: token
      });
    } else if (wxCode) {
      commonService
        .getWxcode({
          tenantId: tenantId,
          weChatId: weChatId,
          globalUserId: ck.cookie("globalUserId"),
          wxCode: wxCode,
          appId: appid
        })
        .subscribe(data => {
          if (data.result == "0") {
            token = data.content.token;
            tokenInfo = data.content.tokenInfo;
            ck.cookie("openId_" + weChatId, token, {
              expires: 1 / 12,
              domain: domain,
              path: "/"
            });
            ck.cookie("verify_" + weChatId, token, {
              expires: 1 / 12,
              domain: domain,
              path: "/"
            });
            ck.cookie("verifyInfo_" + weChatId, tokenInfo, {
              expires: 1 / 12,
              domain: domain,
              path: "/"
            });

            if (data.content.schemaId && data.content.session) {
              let smarketMember = {
                session: data.content.session,
                memberId: data.content.memberId
              };
              ck.cookie(
                "smarketMember_" + data.content.schemaId,
                smarketMember,
                {
                  domain: domain,
                  path: "/",
                  expires: 1
                }
              );
            }

            defer.resolve({
              tokenInfo: tokenInfo,
              token: token
            });
          } else {
            this.authorization(
              {
                weChatId: weChatId,
                scope: scope
              },
              "auth"
            ).fail(() => {
              defer.reject();
            });
          }
        });
    } else if (code) {
      commonService.getTokenByCode({ code: code }).subscribe(data => {
        if (data.result == "0") {
          let weChatInfo = data.content;
          token = weChatInfo.token;
          tokenInfo = weChatInfo.tokenInfo;
          ck.cookie("openId_" + weChatId, token, {
            expires: 1 / 12,
            domain: domain,
            path: "/"
          });
          ck.cookie("verify_" + weChatId, token, {
            expires: 1 / 12,
            domain: domain,
            path: "/"
          });
          ck.cookie("verifyInfo_" + weChatId, tokenInfo, {
            expires: 1 / 12,
            domain: domain,
            path: "/"
          });
          if (weChatInfo.schemaId && weChatInfo.session) {
            let smarketMember = {
              session: weChatInfo.session,
              memberId: weChatInfo.memberId
            };
            ck.cookie("smarketMember_" + weChatInfo.schemaId, smarketMember, {
              domain: domain,
              path: "/",
              expires: 1
            });
          }
          defer.resolve({
            tokenInfo: tokenInfo,
            token: token
          });
        } else {
          this.authorization(
            {
              weChatId: weChatId,
              scope: scope
            },
            "auth"
          ).fail(() => {
            defer.reject();
          });
        }
      });
    } else {
      this.authorization(
        {
          weChatId: weChatId,
          scope: scope
        },
        "auth"
      ).fail(() => {
        defer.reject();
      });
    }
    return defer.promise();
  },
  authorization(options, loginUrlKey) {
    let defer = $.Deferred();
    loginUrlKey = loginUrlKey || "login";
    commonService
      .getOAuth({ weChatId: options["weChatId"] })
      .subscribe(data => {
        if (!data.content || data.content.canOAuth != 1) {
          defer.reject();
          return;
        }
        var loginUrl = data.content[loginUrlKey];

        var zurl = removeSearchParam(window.location.href, "code", "appid");

        loginUrl = URLS.updateSearchParam(
          "return_url",
          encodeURIComponent(zurl),
          loginUrl
        );

        if ("scope" in options) {
          loginUrl = URLS.updateParam("scope", options["scope"], loginUrl);
        }

        if ("sess" in options) {
          loginUrl = URLS.updateParam("sess", options["sess"], loginUrl);
        }

        if ("paramName" in options) {
          loginUrl = URLS.updateParam(
            "paramName",
            options["paramName"],
            loginUrl
          );
        }

        window.location.href = loginUrl;
      });
    return defer.promise();
  }
};
